export const listingConfigDrawer = {
  close: `Chiudi`,
  componentUnavailable: `Componente non disponibile.`,
};
